import BaseModel from './base';
import UserDuplicateMemberProfile from './user-duplicate-member-profile';
import UserDuplicateMemberEvent from './user-duplicate-member-event';

export default class UserDuplicateMember extends BaseModel {
  constructor(userDuplicateMember) {
    super(userDuplicateMember);

    this.id = userDuplicateMember.id;
    this.dispatcher_id = userDuplicateMember.dispatcher_id; // number | null;
    this.is_imported = userDuplicateMember.is_imported;
    this.status = userDuplicateMember.status;
    this.created_at = userDuplicateMember.created_at;
    this.snils = userDuplicateMember.snils; // string | null;
    this.profile = new UserDuplicateMemberProfile(userDuplicateMember.profile);
    this.events = userDuplicateMember?.events
      ? userDuplicateMember.events.map((userDuplicateMemberEvent) => new UserDuplicateMemberEvent(userDuplicateMemberEvent))
      : null;
  }

  get eventsCount() {
    return this.events?.length || 0;
  }
}
